import http from 'utils/http';

export const getCountryFlyersConfiguration = () => {
  return http.get('/businesses/countryFlyers');
};

export const updateCountryFlyersConfiguration = (payload) => {
  return http.put('/businesses/countryFlyers', payload);
};
